import { Validator } from 'vee-validate';
/*

*/
export default (function() {
    //console.log(Validator.extend);
    Validator.extend('inn', {
        getMessage: field => 'The ' + field + ' value is not truthy.',
        validate:(value, [limit]) => {
            //console.log('inn',value)
            if(!value)
                return true;
            if(value.length!=10 && value.length!=12)
                return false;//'Длина ИНН должна быть 10 или 12 символов';
            if(!value.match(/^([0-9]{10}|[0-9]{12})$/))
                return false;//'ИНН должен состоять только из цифр';
            
            // source: https://github.com/kdmatrosov/validation-codes/blob/master/functions/checkINN.js
            //преобразуем в массив
            value = value.split('');
            //для ИНН в 10 знаков
            if ((value.length === 10) && (+value[9] === (((2 * value[0]) + (4 * value[1]) + (10 * value[2]) + (3 * value[3]) + (5 * value[4]) + (9 * value[5]) + (4 * value[6]) + (6 * value[7]) + (8 * value[8])) % 11) % 10)) {
            return true;
            }
            //для ИНН в 12 знаков
            return (value.length === 12) && ((+value[10] === (((7 * value[0]) + (2 * value[1]) + (4 * value[2]) + (10 * value[3]) + (3 * value[4]) + (5 * value[5]) + (9 * value[6]) + (4 * value[7]) + (6 * value[8]) + (8 * value[9])) % 11) % 10) && (+value[11] === (((3 * value[0]) + (7 * value[1]) + (2 * value[2]) + (4 * value[3]) + (10 * value[4]) + (3 * value[5]) + (5 * value[6]) + (9 * value[7]) + (4 * value[8]) + (6 * value[9]) + (8 * value[10])) % 11) % 10));

            //console.log('inn valid');
            // return true;
        }
    },{
        hasTarget:true
    });

    Validator.extend('bic', {
        getMessage: field => 'The ' + field + ' value is not truthy.',
        validate:(value, [limit]) => {
            if(!value)
                return true;
            if(value.length!=9 )
                return false;//'Длина БИК должна быть 9 символов';
            if(!value.match(/^([0-9]{9})$/))
                return false;//'БИК должен состоять только из цифр';

            return true;
        }
    },{
        hasTarget:true
    });

    Validator.extend('passer', {
        getMessage: field => 'The ' + field + ' value is not truthy.',
        validate:(value, [limit]) => {
            if(!value)
                return true;
            if(value.length!=4)
                return false;//'Длина серии паспорта должна быть 4 символов';
            if(!value.match(/^([0-9]{4})$/))
                return false;//'серия паспорта должна состоять только из цифр';
            return true;
        }
    },{
        hasTarget:true
    });
    Validator.extend('pasnum', {
        getMessage: field => 'The ' + field + ' value is not truthy.',
        validate:(value, [limit]) => {
            if(!value)
                return true;
            if(value.length!=6 )
                return false;//'Длина номера паспорта должна быть 6 символов';
            if(!value.match(/^([0-9]{6})$/))
                return false;//'номера паспорта должен состоять только из цифр';

            return true;
        }
    },{
        hasTarget:true
    });

    Validator.extend('snils', {
        getMessage: field => 'The ' + field + ' value is not truthy.',
        validate:(value, [limit]) => {
            let snils = value;
            //console.log('snils',snils)
            if (typeof snils === 'number') {
                snils = snils.toString();
            } else if (typeof snils !== 'string') {
                snils = '';
            }
            if (!snils.length) {
                return true;
            } else if (/[^0-9]/.test(snils)) {
                //error.message = 'СНИЛС может состоять только из цифр';
                return false;
            } else if (snils.length !== 11) {
                //error.message = 'СНИЛС может состоять только из 11 цифр';
                return false;
            } else {
                var sum = 0;
                for (var i = 0; i < 9; i++) {
                    sum += parseInt(snils[i]) * (9 - i);
                }
                var checkDigit = 0;
                if (sum < 100) {
                    checkDigit = sum;
                } else if (sum > 101) {
                    checkDigit = parseInt(sum % 101);
                    if (checkDigit === 100) {
                        checkDigit = 0;
                    }
                }
                if (checkDigit === parseInt(snils.slice(-2))) {
                    //result = true;
                    return true;
                } else {
                    //error.message = 'Неправильное контрольное число';
                    return false;
                }
            }
        }
    },{
        hasTarget:true
    });

}())
    